import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';

import _ from 'lodash';

import classnames from 'classnames';
import styles from './AuthHeader.scss';
import LoginDialog from './LoginDialog';
import ForgotPasswordDialog from './ForgotPasswordDialog';
import RegisterDialog from './RegisterDialog';
import {createRole} from '../helpers/Role';
import DefaultAvatar from 'assets/forms/default-avatar.svg';
import BurgerMenuOpen from 'assets/controls/three-lines-white.svg';
import BurgerMenuClose from 'assets/controls/three-lines-close.svg';
import NotificationCenterContainer from 'components/Notifications/NotificationCenterContainer';
import LogOutDropdown from './LogOutDropdown';
import TextButton from 'components/controls/buttons/TextButton';
import Avatar from 'components/controls/Avatar';
import socketServer from '../../sources/SocketServer';

// extend this if needed.
const ACTIVITY_SUGGESTING_EVENTS = [
    'load',
    'mousemove',
    'mousedown',
    'click',
    'scroll',
    'keypress',
    'touchstart',
    'touchmove',
];
// 30 minutes.
const LOGOUT_TIMEOUT_MILLISECONDS = 30 * 60 * 1000;
// 10 seconds.
const LOGOUT_RESET_DEBOUNCE_MILLISECONDS = 10 * 1000;

/**
 * MOBILE ASSETS
 */
import MobileNavigationBarContainer from '../Header/Mobile/MobileNavigationBarContainer';
import {logout} from 'reducers/auth/authActions';
import Button from 'components/controls/buttons/Button';
import CustomGrid from 'components/controls/grid/CustomGrid';
import SimpleButton from '../controls/buttons/SimpleButton';
import {isMobileAndroid} from "../../sources/webrtc/streams/browserDetector";
import WorkersController from "../../store/WorkersController";

const IGNORE_OUTSIDE_CLICK_CLASSNAME = 'ignore-react-onclickoutside';
export default class AuthHeader extends Component {
    static propTypes = {
        registration: PropTypes.object,
        login: PropTypes.object,
        loginDisplayed: PropTypes.bool,
        loginError: PropTypes.any,
        registrationDisplayed: PropTypes.bool,
        registrationError: PropTypes.any,
        onShowLogin: PropTypes.func.isRequired,
        onHideLogin: PropTypes.func.isRequired,
        onShowRegistration: PropTypes.func.isRequired,
        onHideRegistration: PropTypes.func.isRequired,
        onLogout: PropTypes.func.isRequired,
        onShowForgotPassword: PropTypes.func.isRequired,
        onHideForgotPassword: PropTypes.func.isRequired,
        forgotPasswordDisplayed: PropTypes.bool,
        forgotPasswordError: PropTypes.any,
        forgotPassword: PropTypes.any,
        registerDialogType: PropTypes.string
    };

    state = {
        isOpenLogout: false,
        isOpenMobileNavBar: false,
        logoutTimeout: null,
    };

    handleLogout = () => {
        const {onLogout} = this.props;
        const isConsultation = window.location.pathname.includes('consultation');
        if (isConsultation) return;

        sessionStorage.removeItem('isClosedStripeInactiveModal');

        if (isMobileAndroid()) {
            socketServer.closeConnection()
            Cookies.remove("isAuthorized");
            window.location.reload();
        }

        onLogout();
    }

    _resetTimeout = () => {
        const {login} = this.props;
        const {logoutTimeout} = this.state;
        const isConsultation = window.location.pathname.includes('consultation');
        if (login && !isConsultation) {
            if (logoutTimeout) clearTimeout(logoutTimeout);
            this.setState({
                logoutTimeout: setTimeout(this.handleLogout, LOGOUT_TIMEOUT_MILLISECONDS),
            });
        }
    };

    componentDidMount() {
        WorkersController.registerWorker('/authWorker.js');
        WorkersController.addMessagesListener();

        this.resetTimeout = _.debounce(this._resetTimeout, LOGOUT_RESET_DEBOUNCE_MILLISECONDS);
        ACTIVITY_SUGGESTING_EVENTS.forEach((eventKey) => {
            window.addEventListener(
                eventKey,
                this.resetTimeout,
            );
        });
    }

    componentWillUnmount() {
        const {logoutTimeout} = this.state;
        if (logoutTimeout) clearTimeout(logoutTimeout);

        ACTIVITY_SUGGESTING_EVENTS.forEach((eventKey) => {
            window.removeEventListener(
                eventKey,
                this.resetTimeout,
            )
        })
    }

    componentWillReceiveProps(next) {
        if (this.isAdminLogged(next)) {
            window.location.href = '/admin';
        }
    }

    isAdminLogged(props) {
        if (!(!this.props.login && props.login))
            return false;
        const role = createRole(props);
        return role.isAdmin();
    }

    render() {
        const {login} = this.props;

        if (login)
            return this.renderForRegisteredUser();

        return this.renderForGuest();
    }

    renderForRegisteredUser() {
        const {login} = this.props;
        const role = createRole({login});
        if (role.isAdmin())
            return this.renderForAdmin();

        return this.renderForAuthorized();
    }

    renderForAdmin() {
        const {login} = this.props;
        return (
            <div className={styles.container}>
                <NotificationCenterContainer className={styles.doNotHideOnMobile} />
                <Button
                    label={loc('logout-label')}
                    onClick={this.handleLogout}

                />
                {this.getMobileNavBar(createRole({login}))}
            </div>
        );
    }

    renderForAuthorized() {
        const {isOpenLogout} = this.state;
        const {login = {user: {}}, onLogoutToAdmin} = this.props;

        const previousRole = Cookies.get('previousRole');
        const {fullName, avatar} = login.user;
        const role = createRole({login});
        const title = role.isDoctor() ? 'Dr.' : '';
        return (
            <div className={styles.container}>
                <NotificationCenterContainer className={styles.doNotHideOnMobile} />
                <CustomGrid
                    container
                    direction="column"
                    align="end"
                >
                    <div className={styles.name}>{`${title} ${fullName}`}</div>
                    {previousRole === 'admin' && (
                        <TextButton
                            onClick={onLogoutToAdmin}
                        >
                            {loc('back-to-admin')}
                        </TextButton>
                    )}
                </CustomGrid>

                <Avatar
                    onClick={this.toggleLogout}
                    className={classnames(styles.avatar, IGNORE_OUTSIDE_CLICK_CLASSNAME)}
                    src={avatar ? avatar : DefaultAvatar}
                />
                <LogOutDropdown
                    onLogout={this.handleLogout}
                    isVisible={isOpenLogout}
                    onClose={::this.closeLogout}
                    role={role}
                />
                {this.getMobileNavBar(role)}
            </div>
        );
    }

    getMobileNavBar(role) {
        const {isOpenMobileNavBar} = this.state;
        const props = {
            ...this.props,
            show: isOpenMobileNavBar,
            role: role,
            onHide: :: this.toggleShowMobileState
        };

        const classNames = classnames(styles.mobileNavContainer, styles.doNotHideOnMobile);
        const switcherIcon = isOpenMobileNavBar ? BurgerMenuClose : BurgerMenuOpen;

        return (
            <div className={classNames}>
                <div onClick={::this.toggleShowMobileState}
                     className={classnames(styles.mobileNavSwitcher, IGNORE_OUTSIDE_CLICK_CLASSNAME)}
                     style={{backgroundImage: `url(${switcherIcon})`}}
                />
                <MobileNavigationBarContainer {...props} />
            </div>
        );
    }

    toggleShowMobileState() {
        this.setState({
            isOpenMobileNavBar: !this.state.isOpenMobileNavBar
        });
    }

    toggleLogout = () => {
        this.setState({
            isOpenLogout: !this.state.isOpenLogout
        });
    };

    closeLogout() {
        this.setState({
            isOpenLogout: false
        });
    };

    renderForGuest() {
        const {
            onShowLogin, loginDisplayed,
            registrationDisplayed, registration,
            registrationError, loginError, login,
            forgotPassword, forgotPasswordDisplayed, forgotPasswordError,
            registerDialogType,
            onLoginUserFromRegister,
            location,
        } = this.props;
        const LoginButtonComponent = location.pathname === '/' ? SimpleButton : Button;

        return (
            <div className={styles.container}>
                <CustomGrid
                    container
                    spacing="m"
                    alignItems="center"
                >
                    <CustomGrid item>
                        <Button
                            label={loc('sign-up')}
                            className={styles.headerButton}
                            onClick={this.handleSignUp}
                        />
                    </CustomGrid>
                    <CustomGrid item>
                        {location.pathname === '/'
                            ? (
                                <SimpleButton
                                    onClick={onShowLogin}
                                    className={styles.loginButton}
                                >
                                    {loc('login-label')}
                                </SimpleButton>
                            )
                            : (
                                <LoginButtonComponent
                                    color="tertiary"
                                    label={loc('login-label')}
                                    onClick={onShowLogin}
                                />
                            )}
                    </CustomGrid>
                </CustomGrid>


                {registrationDisplayed &&
                    <RegisterDialog
                        onLoginUserFromRegister={onLoginUserFromRegister}
                        onClose={this.handleCloseRegisterDialog}
                        onLoginLinkClick={this.handleLoginLinkClick}
                        registration={registration}
                        activeTab={registerDialogType}
                        registrationError={registrationError}
                        onLogout={this.handleLogout}
                    />}
                {loginDisplayed && <LoginDialog onClose={this.handleCloseLoginDialog}
                    onSignUpLinkClick={this.handleSignUp}
                    onForgotPasswordClick={this.handleForgotPasswordClick}
                    loginError={loginError} login={login} />}

                {forgotPasswordDisplayed && <ForgotPasswordDialog onClose={this.props.onHideForgotPassword}
                    onBackClick={this.handleBackForgotPassword}
                    forgotPasswordError={forgotPasswordError}
                    forgotPassword={forgotPassword} />
                }
                {this.getMobileNavBar(createRole(this.props))}
            </div>
        );
    }

    handleSignUp = () => {
        const {onShowRegistration, onHideLogin} = this.props;
        onHideLogin && onHideLogin();
        onShowRegistration && onShowRegistration();
    };

    handleCloseLoginDialog = () => {
        this.props.onHideLogin();
    };

    handleCloseRegisterDialog = () => {
        this.props.onHideRegistration();
    };

    handleLoginLinkClick = () => {
        this.props.onHideRegistration();
        this.props.onShowLogin();
    };

    handleForgotPasswordClick = () => {
        this.props.onHideLogin();
        this.props.onShowForgotPassword();
    };

    handleBackForgotPassword = () => {
        this.props.onHideForgotPassword();
        this.props.onShowLogin();
    };
}



// WEBPACK FOOTER //
// ./src/components/Auth/AuthHeader.js